import { createSlice } from '@reduxjs/toolkit';

import { adminApi } from '~/services/rtkQuery/admin';
import { LinkStatus } from '~/types/models';

export interface GeneratedLinkState {
  data: {
    uuid: string;
    email: string;
    companyId: number;
    status: LinkStatus;
    expiredAt: string;
  } | null;
}

const initialState: GeneratedLinkState = {
  data: null,
};

export const generatedLinkSlice = createSlice({
  name: 'generatedLink',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addMatcher(adminApi.endpoints.validateLink.matchFulfilled, (state, { payload }) => {
      state.data = {
        uuid: payload.result.uuid,
        email: payload.result.email,
        companyId: payload.result.company_id,
        expiredAt: payload.result.expired_at,
        status: payload.result.status,
      };
    });
  },
});

export const generatedLinkReducer = generatedLinkSlice.reducer;
